export default __webpack_public_path__ + "static/media/bg-transparency.55713ffb.png";